import { IonButton, IonIcon, IonSkeletonText, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { CHOSEN_CORE_VALUES_LIMIT } from "@/lib/constants";
import { arrowRightIcon } from "@/lib/icons/@heroicons/react/16/solid";
import { useFeatureFlagsContext } from "@/lib/posthog/feature-flags/context";
import { queryOptions_coreValuesChosen } from "@/lib/query/functions/core-values/chosen";
import { Routes } from "@/lib/router";

export function RefineCoreValuesWidget() {
	const { t } = useTranslation();
	const featureFlags = useFeatureFlagsContext();
	const { data, isLoading } = useQuery(queryOptions_coreValuesChosen());

	if (isLoading) {
		return <IonSkeletonText animated className="h-42 rounded-3xl" />;
	}

	const firstUnrefinedCoreValue = data?.find((coreValue) => !coreValue.customName);
	const shouldShowWidget =
		data?.length === CHOSEN_CORE_VALUES_LIMIT &&
		firstUnrefinedCoreValue &&
		featureFlags.canRefineCoreValue;

	if (!shouldShowWidget) {
		return <></>;
	}

	return (
		<div className="bg-brown-100 flex flex-col gap-2 rounded-3xl p-4">
			<IonText className="text-brown-700 text-2xl font-bold">
				{t("widgets.refine-core-values.title")}
			</IonText>
			<IonText className="text-brown-600">
				{t("widgets.refine-core-values.description", {
					coreValue: firstUnrefinedCoreValue.coreValue.name,
				})}
			</IonText>

			<IonButton
				className="ion-py-2.5 ion-rounded-lg min-h-10"
				routerLink={Routes.CoreValuesChat({ id: firstUnrefinedCoreValue.id })}
			>
				{t("widgets.refine-core-values.action")}
				<IonIcon slot="end" icon={arrowRightIcon} className="ml-2 size-5 opacity-60" />
			</IonButton>
		</div>
	);
}
